import styled from 'styled-components';

export const EMPTY_CARD_STATE_HEIGHT = '15rem';

export const InvestorDetailsEmptyCardStateStyles = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	min-height: ${EMPTY_CARD_STATE_HEIGHT};
`;
